import { en } from './strings.en'

/**
 * The web chrome's Arabic strings (B9) — the same keys as `strings.en.ts`, in the same order.
 * `satisfies` is the contract: a missing or extra key fails `tsc`.
 */
export const ar = {
  'account.backToChats': 'العودة إلى المحادثات',
  'account.cancel': 'إلغاء',
  'account.changePassword': 'تغيير كلمة المرور',
  'account.changePhoto': 'تغيير صورة الملف الشخصي',
  'account.changingPassword': 'جارٍ تغيير كلمة المرور',
  'account.confirmPassword': 'تأكيد كلمة المرور الجديدة',
  'account.currentPassword': 'كلمة المرور الحالية',
  'account.displayName': 'الاسم المعروض',
  'account.errorChangePassword': 'تعذّر تغيير كلمة المرور.',
  'account.errorCurrentPassword': 'كلمة المرور الحالية غير صحيحة.',
  'account.errorLoadSessions': 'تعذّر تحميل جلساتك.',
  'account.errorNameLength': 'يتراوح الاسم المعروض بين حرف واحد و64 حرفًا.',
  'account.errorNewPasswordShort': 'يجب أن تتكوّن كلمة المرور الجديدة من 8 أحرف على الأقل.',
  'account.errorPasswordMismatch': 'كلمتا المرور الجديدتان غير متطابقتين.',
  'account.errorPrivacy': 'تعذّر تحديث إعدادات الخصوصية.',
  'account.errorRevoke': 'تعذّر إبطال تلك الجلسة.',
  'account.errorSaveName': 'تعذّر حفظ اسمك.',
  'account.errorUploadPhoto': 'تعذّر رفع الصورة.',
  'account.language': 'اللغة',
  'account.languageHint': 'تتبع الواجهة هذا الاختيار؛ و«النظام» يتبع لغة هذا الجهاز. أما الرسائل فتحفظ اتجاهها الخاص في كل الأحوال.',
  'account.languageSystem': 'النظام',
  'account.lastSeen': 'آخر ظهور',
  'account.lastSeenHint': 'عند إيقافه، لن يرى أحد متى كنت متصلًا — لا في المحادثة ولا في دليل الأعضاء. وستبقى ترى آخر ظهور للآخرين.',
  'account.loading': 'جارٍ التحميل…',
  'account.loadingSessions': 'جارٍ تحميل جلساتك',
  'account.me': 'أنا',
  'account.nameSaved': 'تم حفظ الاسم.',
  'account.neverSeen': 'لم يظهر قط',
  'account.newPassword': 'كلمة المرور الجديدة',
  'account.noDevices': 'لا توجد أجهزة مسجّلة الدخول.',
  'account.password': 'كلمة المرور',
  'account.passwordChanged': 'تم تغيير كلمة المرور.',
  'account.passwordHint': '8 أحرف على الأقل. تغييرها يبقيك مسجّل الدخول هنا.',
  'account.privacy': 'الخصوصية',
  'account.privacySaved': 'تم حفظ إعدادات الخصوصية.',
  'account.profile': 'الملف الشخصي',
  'account.readReceipts': 'إشعارات القراءة',
  'account.readReceiptsHint': 'عند إيقافها، لن يُخبَر أحد بأنك قرأت رسالته — ولا حتى كاتبها. وستبقى ترى حالة القراءة عند كل من يبقيها مفعّلة.',
  'account.revoke': 'إبطال',
  'account.revokeDevice': 'إبطال {name}',
  'account.revokeDeviceConfirm': 'سيتم تسجيل خروج {name} عند طلبه التالي.',
  'account.revokeThisDeviceConfirm': '{name} هو هذا الجهاز. إبطاله يسجّل خروجك هنا، وستحتاج إلى رمز دعوة أو استرداد لتسجيل الدخول مجددًا.',
  'account.revoking': 'جارٍ الإبطال',
  'account.save': 'حفظ',
  'account.saving': 'جارٍ الحفظ',
  'account.sessions': 'الجلسات',
  'account.sessionsHint': 'إبطال الجلسة يسجّل خروجها عند طلبها التالي. الجلسة المعلَّمة بـ«هذا الجهاز» هي هذا المتصفح — وإبطالها يسجّل خروجك هنا.',
  'account.tapPhoto': 'اضغط على الصورة لتغييرها.',
  'account.thisDevice': 'هذا الجهاز',
  'account.title': 'الحساب',
  'account.unknownPlatform': 'منصة غير معروفة',
  'account.unnamedDevice': 'جهاز بلا اسم',
  'adminRedirect.body': 'أصبحت الموافقات والأعضاء والدعوات وروابط الاسترداد على موقعها الخاص الآن. نأخذك إلى',
  'adminRedirect.title': 'انتقلت لوحة المشرف إلى وحدة التحكم',
  'approval.notApproved': 'لم تتم الموافقة',
  'approval.pendingBody': 'تم إنشاء حسابك، وعلى المشرف السماح له بالدخول قبل أن تتمكن من استخدام olmt·call. تتحقق هذه الصفحة من تلقاء نفسها — اتركها مفتوحة وسيُفتح التطبيق من تلقاء نفسه.',
  'approval.rejectedBody': 'رفض المشرف هذا الحساب.',
  'approval.signedInAs': 'مسجّل الدخول باسم',
  'approval.suspendedBody': 'تم تعليق هذا الحساب من قِبل المشرف.',
  'approval.unreachable': 'تعذّر الوصول إلى الخادم — ما زلنا نحاول.',
  'approval.useDifferentAccount': 'استخدام حساب آخر',
  'approval.waiting': 'في انتظار الموافقة',
  'auth.backToSignIn': 'العودة إلى تسجيل الدخول',
  'auth.createAccount': 'إنشاء حساب',
  'auth.creatingAccount': 'جارٍ إنشاء حسابك',
  'auth.deviceName': 'اسم الجهاز',
  'auth.deviceNameHint': 'فقط لتتمكن من تمييز هذا الهاتف في قائمة أجهزتك. وهو لا يظهر لأي شخص آخر.',
  'auth.displayName': 'الاسم المعروض',
  'auth.email': 'البريد الإلكتروني',
  'auth.errorBadCredentials': 'البريد الإلكتروني أو كلمة المرور غير صحيحة.',
  'auth.errorCredentials': 'أدخل بريدك الإلكتروني وكلمة المرور.',
  'auth.errorDisplayName': 'أدخل اسمًا معروضًا.',
  'auth.errorEmail': 'أدخل بريدك الإلكتروني.',
  'auth.errorEmailTaken': 'هذا البريد الإلكتروني مرتبط بحساب بالفعل. سجّل الدخول بدلًا من ذلك.',
  'auth.errorGeneric': 'حدث خطأ ما. حاول مرة أخرى.',
  'auth.errorInviteCode': 'أدخل رمز الدعوة أو الاسترداد.',
  'auth.errorInviteDisplayName': 'أدخل اسمًا معروضًا للانضمام كحساب جديد.',
  'auth.errorInviteInvalid': 'رابط الدعوة هذا لم يعد صالحًا.',
  'auth.errorNetwork': 'تعذّر الوصول إلى الخادم. تحقّق من اتصالك.',
  'auth.errorPasswordShort': 'يجب أن تتكوّن كلمة مرورك من 8 أحرف على الأقل.',
  'auth.errorRateLimited': 'محاولات كثيرة جدًا — انتظر لحظة ثم حاول مرة أخرى.',
  'auth.errorTooLarge': 'كان ذلك الطلب كبيرًا جدًا.',
  'auth.haveInvite': 'لديك دعوة؟',
  'auth.inviteCode': 'رمز الدعوة أو الاسترداد',
  'auth.inviteCodeHint': 'هل تنضم للمرة الأولى؟ أدخل اسمًا معروضًا أيضًا. هل تضيف هذا الجهاز إلى حساب لديك بالفعل؟ اتركه فارغًا.',
  'auth.join': 'انضمام',
  'auth.joinNotice': 'رمز الدعوة ينشئ حسابك؛ ورمز الاسترداد يضيف هذا الجهاز إلى حساب لديك بالفعل. يبدو الاثنان متشابهين — الصق أيًّا منهما أُعطي لك.',
  'auth.joinTitle': 'الانضمام بدعوة',
  'auth.joining': 'جارٍ الانضمام',
  'auth.modeGroup': 'إنشاء حساب أو تسجيل الدخول',
  'auth.password': 'كلمة المرور',
  'auth.passwordHint': '8 أحرف على الأقل.',
  'auth.signIn': 'تسجيل الدخول',
  'auth.signingIn': 'جارٍ تسجيل الدخول',
  'auth.signupNotice': 'تنتظر الحسابات الجديدة موافقة المشرف قبل أن يُفتح التطبيق — سترى شاشة انتظار حتى ذلك الحين، ويدخل التطبيق من تلقاء نفسه بمجرد الموافقة عليك.',
  'auth.tagline': 'خط عائلتك الخاص. تبقى المكالمات والرسائل الصوتية والرسائل على هذا الخادم.',
  'call.answer': 'رد',
  'call.answerCall': 'الرد على المكالمة',
  'call.answeredElsewhere': 'تم الرد من جهاز آخر',
  'call.answeredElsewhereDetail': 'المكالمة جارية على الجهاز الذي رددت منه.',
  'call.audio': 'صوت المكالمة',
  'call.backToChats': 'العودة إلى المحادثات',
  'call.bluetooth': 'بلوتوث',
  'call.camera': 'الكاميرا',
  'call.cameraN': 'الكاميرا {number}',
  'call.cameraOff': 'الكاميرا متوقفة',
  'call.cameraTurnOff': 'إيقاف الكاميرا',
  'call.cameraTurnOn': 'تشغيل الكاميرا',
  'call.cancelCall': 'إلغاء المكالمة',
  'call.connected': 'متصل',
  'call.connecting': 'جارٍ الاتصال…',
  'call.couldNotJoin': 'تعذّر الانضمام إلى المكالمة.',
  'call.decline': 'رفض',
  'call.declineCall': 'رفض المكالمة',
  'call.declinedElsewhere': 'تم الرفض من جهاز آخر',
  'call.declinedElsewhereDetail': 'توقّف هذا الجهاز عن الرنين.',
  'call.deviceDefault': 'افتراضي',
  'call.deviceSwitchFailed': 'تعذّر تبديل مخرج الصوت.',
  'call.deviceUnavailable': 'الكاميرا أو الميكروفون غير متاح.',
  'call.disconnected': 'انقطع الاتصال',
  'call.dismiss': 'تجاهل',
  'call.earpiece': 'سماعة الأذن',
  'call.endCall': 'إنهاء المكالمة',
  'call.ended': 'انتهت المكالمة',
  'call.everyoneHungUp': 'أنهى الجميع المكالمة.',
  'call.headphones': 'سماعات الرأس',
  'call.hostDisconnected': 'انقطع الاتصال',
  'call.hostDisconnectedReason': 'انقطع الاتصال: {reason}',
  'call.hostJoinFailed': 'فشل الانضمام — {detail}',
  'call.hostMissingCallId': 'معرّف المكالمة مفقود',
  'call.hostNoSession': 'لا توجد جلسة — لم يسجّل هذا الـWebView الدخول قط',
  'call.incomingVideoCall': 'مكالمة فيديو واردة',
  'call.incomingVideoCallFrom': 'مكالمة فيديو واردة من {name}',
  'call.incomingVoiceCall': 'مكالمة صوتية واردة',
  'call.incomingVoiceCallFrom': 'مكالمة صوتية واردة من {name}',
  'call.invitePeople': 'دعوة أشخاص',
  'call.join': 'انضمام',
  'call.joining': 'جارٍ الانضمام',
  'call.joiningCall': 'جارٍ الانضمام إلى المكالمة',
  'call.joiningCallEllipsis': 'جارٍ الانضمام إلى المكالمة…',
  'call.levelPrompt': 'قل شيئًا — هكذا يظهر مستوى صوتك',
  'call.loadingCall': 'جارٍ تحميل المكالمة',
  'call.micOff': 'ميكروفونك متوقف',
  'call.micTurnOff': 'إيقاف الميكروفون',
  'call.micTurnOn': 'تشغيل الميكروفون',
  'call.microphone': 'الميكروفون',
  'call.microphoneN': 'الميكروفون {number}',
  'call.muteMic': 'كتم الميكروفون',
  'call.noLongerRinging': 'لم تعد هذه المكالمة ترن على هذا الخادم.',
  'call.output': 'مخرج الصوت',
  'call.outputN': 'مخرج الصوت {number}',
  'call.peopleCount': '{count} أشخاص',
  'call.personCount': '{count} شخص',
  'call.prejoinCameraMicHint': 'تحقّق من الكاميرا والميكروفون',
  'call.prejoinMicHint': 'تحقّق من الميكروفون',
  'call.reconnecting': 'جارٍ إعادة الاتصال…',
  'call.ringingMany': 'جارٍ الاتصال بـ{count} أشخاص…',
  'call.ringingOne': 'جارٍ الاتصال بـ{name}…',
  'call.screen': 'الشاشة',
  'call.shareScreen': 'مشاركة الشاشة',
  'call.someone': 'شخص ما',
  'call.speaker': 'مكبر الصوت',
  'call.stopScreenShare': 'إيقاف مشاركة الشاشة',
  'call.tapToHearAudio': 'اضغط لسماع الصوت',
  'call.unavailable': 'المكالمة غير متاحة',
  'call.unknownError': 'خطأ غير معروف',
  'call.unmuteMic': 'إلغاء كتم الميكروفون',
  'call.videoCall': 'مكالمة فيديو',
  'call.voiceCall': 'مكالمة صوتية',
  'call.volume': 'مستوى الصوت',
  'call.volumeFor': 'مستوى الصوت لـ{name}',
  'call.waitingForOthers': 'في انتظار الآخرين',
  'call.waitingForVideo': 'في انتظار الفيديو',
  'call.you': 'أنت',
  'calls.backToChats': 'العودة إلى المحادثات',
  'calls.callBack': 'إعادة الاتصال',
  'calls.duration': 'استمرت المكالمة {duration}',
  'calls.empty': 'لا توجد مكالمات بعد.',
  'calls.failed': 'تعذّر بدء المكالمة.',
  'calls.incoming': 'مكالمة واردة',
  'calls.loadFailed': 'تعذّر تحميل المكالمات.',
  'calls.loading': 'جارٍ تحميل المكالمات',
  'calls.missed': 'مكالمة فائتة',
  'calls.open': 'سجل المكالمات',
  'calls.outgoing': 'مكالمة صادرة',
  'calls.title': 'المكالمات',
  'chat.add': 'إضافة',
  'chat.addPeople': 'إضافة أشخاص',
  'chat.addPeopleCount': 'إضافة {count} أشخاص',
  'chat.addToHomeScreen': 'إضافة إلى الشاشة الرئيسية',
  'chat.adding': 'جارٍ الإضافة…',
  'chat.adminConsole': 'لوحة تحكم المشرف',
  'chat.back': 'رجوع',
  'chat.backToChats': 'العودة إلى المحادثات',
  'chat.callInProgressOne': 'مكالمة جارية · {count} عضو',
  'chat.callInProgressOther': 'مكالمة جارية · {count} أعضاء',
  'chat.callsInBackground': 'المكالمات في الخلفية',
  'chat.cancel': 'إلغاء',
  'chat.cancelEdit': 'إلغاء التعديل',
  'chat.cancelSelect': 'إلغاء التحديد',
  'chat.changePhoto': 'تغيير الصورة',
  'chat.chatDetails': 'تفاصيل المحادثة',
  'chat.chatPinned': 'مثبّتة في الأعلى',
  'chat.chatUnpinned': 'غير مثبّتة',
  'chat.chats': 'المحادثات',
  'chat.chooseWhoToAdd': 'اختر من تريد إضافته إلى هذه المحادثة.',
  'chat.chooseWhoToRing': 'اختر من تريد رنّه إلى هذه المكالمة.',
  'chat.close': 'إغلاق',
  'chat.closePhoto': 'إغلاق الصورة',
  'chat.connecting': 'جارٍ الاتصال…',
  'chat.contactInfo': 'معلومات جهة الاتصال',
  'chat.copied': 'تم النسخ.',
  'chat.copy': 'نسخ',
  'chat.copyFailed': 'تعذّر نسخ الرسالة.',
  'chat.couldNotAddMembers': 'تعذّر إضافتهم إلى المحادثة.',
  'chat.couldNotChangePhoto': 'تعذّر تغيير الصورة.',
  'chat.couldNotCreateChat': 'تعذّر إنشاء المحادثة.',
  'chat.couldNotLeave': 'تعذّر مغادرة المحادثة.',
  'chat.couldNotLoadChat': 'تعذّر تحميل هذه المحادثة.',
  'chat.couldNotLoadMembers': 'تعذّر تحميل الأعضاء.',
  'chat.couldNotRemoveMember': 'تعذّر إزالتهم من المحادثة.',
  'chat.couldNotRename': 'تعذّر إعادة تسمية المحادثة.',
  'chat.couldNotRing': 'تعذّر رنّهم إلى المكالمة.',
  'chat.couldNotStartCall': 'تعذّر بدء المكالمة.',
  'chat.couldNotUpdateMute': 'تعذّر تحديث إعدادات الإشعارات.',
  'chat.couldNotUpdatePin': 'تعذّر تحديث التثبيت.',
  'chat.createGroup': 'إنشاء مجموعة',
  'chat.creating': 'جارٍ الإنشاء…',
  'chat.delete': 'حذف',
  'chat.deleteConfirmBody': 'ستُحذف هذه الرسالة عند الجميع في المحادثة.',
  'chat.deleteConfirmTitle': 'حذف الرسالة؟',
  'chat.deleteFailed': 'تعذّر حذف الرسالة.',
  'chat.deleteSelected': 'ستُحذف {count} رسائل عند الجميع في المحادثة.',
  'chat.deleting': 'جارٍ الحذف',
  'chat.disappearing24Hours': '24 ساعة',
  'chat.disappearing7Days': '7 أيام',
  'chat.disappearing90Days': '90 يومًا',
  'chat.disappearingBanner': 'تختفي رسائل هذه المحادثة بعد {window}.',
  'chat.disappearingFailed': 'تعذّر تغيير مؤقّت اختفاء الرسائل.',
  'chat.disappearingHint': 'تُحذف الرسائل الأقدم من المؤقّت للجميع في هذه المحادثة. والحالة الافتراضية هي الإيقاف.',
  'chat.disappearingMessages': 'الرسائل المؤقتة',
  'chat.disappearingOff': 'متوقف',
  'chat.disappearingUpdating': 'جارٍ تحديث المؤقّت',
  'chat.downloadFile': 'تنزيل {name}',
  'chat.edit': 'تعديل',
  'chat.editFailed': 'تعذّر حفظ التعديل.',
  'chat.edited': 'تم التعديل',
  'chat.editing': 'تعديل الرسالة',
  'chat.enableNotifications': 'تفعيل الإشعارات',
  'chat.everyoneAlreadyIn': 'الجميع موجودون في هذه المحادثة بالفعل.',
  'chat.export': 'تصدير المحادثة',
  'chat.exportBuilding': 'جارٍ تجهيز نسختك',
  'chat.exportFailed': 'تعذّر تصدير المحادثة.',
  'chat.exportHint': 'ملف ZIP يضم الرسائل ووسائطها، يُجهَّز لك ويُحفظ لمدة أسبوع. ولا يحذف التصدير شيئًا — إنه نسخة.',
  'chat.exportMediaOne': '{count} ملف وسائط',
  'chat.exportMediaOther': '{count} ملفات وسائط',
  'chat.exportMessagesOne': '{count} رسالة',
  'chat.exportMessagesOther': '{count} رسائل',
  'chat.exportReady': 'تم تصدير {messages} و{media} ({size}).',
  'chat.exportTitle': 'نسختك من هذه المحادثة',
  'chat.fallbackTitle': 'محادثة',
  'chat.forward': 'إعادة توجيه',
  'chat.forwardFailed': 'تعذّرت إعادة توجيه الرسالة.',
  'chat.forwardPick': 'اختر المحادثات التي تريد إعادة التوجيه إليها.',
  'chat.forwardSend': 'إرسال',
  'chat.forwardTitle': 'إعادة التوجيه إلى',
  'chat.forwarded': 'تمت إعادة التوجيه',
  'chat.forwardedTo': 'تمت إعادة التوجيه إلى {count} من المحادثات',
  'chat.forwardedToOne': 'تمت إعادة التوجيه إلى محادثة واحدة',
  'chat.forwarding': 'جارٍ إعادة التوجيه…',
  'chat.groupDetails': 'تفاصيل المجموعة',
  'chat.groupName': 'اسم المجموعة',
  'chat.groupNameOptional': 'اسم المجموعة (اختياري)',
  'chat.groupNamePlaceholder': 'العائلة',
  'chat.groupSubtitle': '{members} · {online} متصل',
  'chat.inCall': 'في مكالمة',
  'chat.inviteToCall': 'دعوة إلى مكالمة',
  'chat.leave': 'مغادرة',
  'chat.leaveChat': 'مغادرة المحادثة',
  'chat.leaveConfirm': 'مغادرة {name}؟ ستتوقف عن استلام رسائلها.',
  'chat.leaving': 'جارٍ المغادرة',
  'chat.liveCount': 'مباشر · {count}',
  'chat.loadOlderMessages': 'تحميل الرسائل الأقدم',
  'chat.loading': 'جارٍ التحميل…',
  'chat.loadingChatDetails': 'جارٍ تحميل تفاصيل المحادثة',
  'chat.loadingMembers': 'جارٍ تحميل الأعضاء',
  'chat.loadingMessages': 'جارٍ تحميل الرسائل',
  'chat.loadingOlderMessages': 'جارٍ تحميل الرسائل الأقدم',
  'chat.loadingPhoto': 'جارٍ تحميل الصورة',
  'chat.loadingVideo': 'جارٍ تحميل الفيديو',
  'chat.me': 'أنا',
  'chat.memberCountOne': '{count} عضو',
  'chat.memberCountOther': '{count} أعضاء',
  'chat.memberFallback': 'عضو',
  'chat.membersHeading': 'الأعضاء · {count}',
  'chat.mentionInsert': 'الإشارة إلى {handle}',
  'chat.mentionedYou': 'أشار إليك',
  'chat.mentionsEmpty': 'لا يوجد عضو بهذا المعرّف.',
  'chat.mentionsTitle': 'الإشارة إلى عضو',
  'chat.menu': 'القائمة',
  'chat.messageActions': 'إجراءات الرسالة',
  'chat.messageDeleted': 'تم حذف الرسالة',
  'chat.mute1Week': 'أسبوع واحد',
  'chat.mute8Hours': '8 ساعات',
  'chat.muteForever': 'إلى الأبد',
  'chat.muted': 'مكتوم',
  'chat.mutedForever': 'مكتوم إلى الأبد',
  'chat.mutedUntil': 'مكتوم حتى {date}',
  'chat.newChat': 'محادثة جديدة',
  'chat.noChats': 'لا توجد محادثات بعد',
  'chat.noChatsHint': 'ابدأ محادثة مع الأشخاص الذين تريدهم فيها. يراها كل من في المحادثة على هاتفه.',
  'chat.noMessages': 'لا رسائل بعد',
  'chat.noOneToInvite': 'لا يوجد أحد آخر في هذه المحادثة لدعوته.',
  'chat.noOtherMembers': 'لا يوجد أعضاء آخرون بعد.',
  'chat.notificationStateBlocked': 'محظور في الإعدادات',
  'chat.notificationStateOff': 'متوقف — تشغيل',
  'chat.notificationStateOn': 'مفعّل',
  'chat.notifications': 'الإشعارات',
  'chat.notificationsBlockedInSettings': 'الإشعارات محظورة في الإعدادات',
  'chat.notificationsEnabled': 'تم تفعيل الإشعارات',
  'chat.notificationsOn': 'الإشعارات مفعّلة',
  'chat.offline': 'غير متصل',
  'chat.offlineNotice': 'غير متصل — لن تصل الرسائل مباشرة.',
  'chat.openAChat': 'افتح محادثة',
  'chat.openAChatHint': 'اختر اسمًا من القائمة على اليسار لقراءتها، أو ابدأ مكالمة من داخل المحادثة.',
  'chat.openChat': 'فتح المحادثة',
  'chat.openPhoto': 'فتح الصورة',
  'chat.pauseVoiceMessage': 'إيقاف الرسالة الصوتية مؤقتًا',
  'chat.photo': 'صورة',
  'chat.photoUnavailable': 'الصورة غير متاحة',
  'chat.photoUploading': 'جارٍ الرفع…',
  'chat.pickMembersHint': 'اختر عضوًا واحدًا لمحادثة مباشرة، أو عدة أعضاء لمجموعة.',
  'chat.pin': 'تثبيت',
  'chat.pinFailed': 'تعذّر تثبيت الرسالة.',
  'chat.pinned': 'مثبّتة',
  'chat.pinnedMessage': 'رسالة مثبّتة',
  'chat.playVideo': 'تشغيل الفيديو',
  'chat.playVoiceMessage': 'تشغيل الرسالة الصوتية',
  'chat.previewCall': 'مكالمة',
  'chat.previewFile': 'ملف',
  'chat.previewVideo': 'فيديو',
  'chat.previewVoice': 'رسالة صوتية',
  'chat.react': 'تفاعل',
  'chat.reactFailed': 'تعذّر التفاعل مع الرسالة.',
  'chat.reactWith': 'تفاعل بـ {emoji}',
  'chat.read': 'مقروء',
  'chat.remove': 'إزالة',
  'chat.removeFromSelection': 'إزالة من التحديد',
  'chat.removeMember': 'إزالة {name}',
  'chat.removeMemberConfirm': 'إزالة {name} من هذه المحادثة؟',
  'chat.removeReaction': 'إزالة {emoji}',
  'chat.removing': 'جارٍ الإزالة',
  'chat.rename': 'إعادة التسمية',
  'chat.reply': 'رد',
  'chat.replyTo': 'رد على {target}',
  'chat.ring': 'رنين',
  'chat.ringCount': 'رنين {count} أشخاص',
  'chat.ringing': 'جارٍ الرنين…',
  'chat.save': 'حفظ',
  'chat.saveEdit': 'حفظ التعديل',
  'chat.select': 'تحديد',
  'chat.selected': '{count} محدد',
  'chat.selectedCount': '{count} محدد',
  'chat.selectedMembers': 'الأعضاء المحددون',
  'chat.sending': 'جارٍ الإرسال',
  'chat.sent': 'مُرسل',
  'chat.signOut': 'تسجيل الخروج',
  'chat.someone': 'شخص ما',
  'chat.systemMessage': 'رسالة نظام',
  'chat.typingIndicator': 'يكتب…',
  'chat.typingMany': '{names} يكتبون',
  'chat.typingOne': '{names} يكتب',
  'chat.unknownAuthor': 'غير معروف',
  'chat.unmute': 'إلغاء الكتم',
  'chat.unmuted': 'غير مكتوم',
  'chat.unpin': 'إلغاء التثبيت',
  'chat.unpinFailed': 'تعذّر إلغاء تثبيت الرسالة.',
  'chat.unreadMessages': 'رسائل غير مقروءة',
  'chat.unreadMessagesSuffix': 'رسائل غير مقروءة',
  'chat.updatingMute': 'جارٍ تحديث إعداد الكتم',
  'chat.updatingPin': 'جارٍ تحديث التثبيت',
  'chat.videoCall': 'مكالمة فيديو',
  'chat.voiceCall': 'مكالمة صوتية',
  'chat.you': 'أنت',
  'chat.youBadge': 'أنت',
  'chat.yourMessage': 'رسالتك',
  'composer.attach': 'إرفاق',
  'composer.attachFile': 'ملف',
  'composer.attachPhoto': 'صورة',
  'composer.attachVideo': 'فيديو',
  'composer.cancelRecording': 'إلغاء التسجيل',
  'composer.cancelReply': 'إلغاء الرد',
  'composer.closeAttachments': 'إغلاق المرفقات',
  'composer.messageNotSent': 'لم تُرسل الرسالة — تحقق من اتصالك.',
  'composer.micBlocked': 'الوصول إلى الميكروفون محظور.',
  'composer.placeholder': 'رسالة',
  'composer.record': 'تسجيل رسالة صوتية',
  'composer.recording': 'جارٍ التسجيل…',
  'composer.reply': 'رد',
  'composer.send': 'إرسال رسالة',
  'composer.sendVoiceMessage': 'إرسال رسالة صوتية',
  'composer.storageFull': 'مساحة القرص على الخادم منخفضة — الرفع متوقف حتى يحرّر المشرف مساحة.',
  'composer.tooLarge': '{name} كبير جدًا بحيث لا يمكن إرساله.',
  'composer.uploadFailed': 'تعذّر رفع {name}.',
  'composer.uploading': 'جارٍ الرفع',
  'composer.voiceMessage': 'رسالة صوتية',
  'notFound.backToChats': 'العودة إلى المحادثات',
  'notFound.body': 'هذا الرابط لا يؤدي إلى أي مكان على هذا الخادم.',
  'notFound.title': 'الصفحة غير موجودة',
  'poll.addOption': 'إضافة خيار',
  'poll.errorOptionCount': 'عدد خيارات الاستطلاع بين 2 و10.',
  'poll.errorOptionEmpty': 'لا يمكن أن يكون الخيار فارغًا.',
  'poll.errorOptionLong': 'الحد الأقصى للخيار 80 حرفًا.',
  'poll.errorQuestion': 'يحتاج الاستطلاع إلى سؤال.',
  'poll.failed': 'تعذّر حفظ تصويتك.',
  'poll.multiple': 'السماح بعدة خيارات',
  'poll.multipleHint': 'يمكن للأعضاء اختيار أكثر من خيار.',
  'poll.option': 'الخيار {number}',
  'poll.question': 'السؤال',
  'poll.removeOption': 'إزالة الخيار {number}',
  'poll.send': 'إرسال الاستطلاع',
  'poll.title': 'استطلاع جديد',
  'poll.unvote': 'إلغاء تصويتك عن {option}',
  'poll.vote': 'التصويت لـ{option}',
  'poll.votes': '{count} أصوات',
  'poll.votesOne': 'صوت واحد',
  'presence.lastSeenDate': 'آخر ظهور {date}',
  'presence.lastSeenHours': 'آخر ظهور قبل {count} س',
  'presence.lastSeenJustNow': 'آخر ظهور الآن',
  'presence.lastSeenMinutes': 'آخر ظهور قبل {count} د',
  'presence.offline': 'غير متصل',
  'presence.online': 'متصل',
  'pwa.dismiss': 'تجاهل',
  'pwa.newVersion': 'يتوفر إصدار جديد.',
  'pwa.offlineReady': 'جاهز للعمل دون اتصال.',
  'pwa.reload': 'إعادة التحميل',
  'ring.allowBackground': 'السماح بالعمل في الخلفية',
  'ring.allowBackgroundHint': 'نقرة واحدة ومربّع حوار نظام واحد — لا تطبيق آخر، ولا يُثبَّت أي شيء.',
  'ring.androidOnlyBody': 'تُعدّ هذه الشاشة تطبيق أندرويد — استثناء البطارية، وسرعة إعادة الاتصال، وإعدادات HiOS التي تحدّد ما إذا كان بإمكان المكالمة أن ترن والتطبيق مغلق. أما في المتصفح فلا يوجد ما يُعدّ: إذ تُسلَّم الإشعارات الفورية عبر خدمة الإشعارات الخاصة بالمتصفح، والتي يديرها الهاتف نيابة عنك بالفعل.',
  'ring.androidOnlyTitle': 'أندرويد فقط',
  'ring.backToChats': 'العودة إلى المحادثات',
  'ring.batterySettings': 'إعدادات البطارية',
  'ring.batteryTitle': 'تحسين البطارية',
  'ring.checkingLink': 'جارٍ التحقق من رابط الخلفية',
  'ring.connectionBody': 'ما دام التطبيق مفتوحًا، يحتفظ التطبيق نفسه بالاتصال. وعندما لا يكون كذلك، يحتفظ أندرويد باتصال واحد في الخلفية — مقبس واحد لكل جهاز، ولا اثنان أبدًا.',
  'ring.connectionTitle': 'الاتصال',
  'ring.exempt': 'مستثنى. لن يقطع Doze ووضع الاستعداد للتطبيقات الاتصال.',
  'ring.fragileSuffix': '(مقصَّر حتى يصبح الرابط محميًا مجددًا)',
  'ring.notExempt': 'غير مستثنى. سيعلّق أندرويد الاتصال عند إطفاء الشاشة، لذا قد تفوتك المكالمات.',
  'ring.nowLabel': 'الآن:',
  'ring.offWithLink': '(متوقف مع الرابط)',
  'ring.openAppSettings': 'فتح إعدادات هذا التطبيق',
  'ring.presetBalancedDetail': 'يعيد الاتصال خلال نحو خمس دقائق · 288 إيقاظًا يوميًا.',
  'ring.presetBalancedLabel': 'متوازن — 5 دقائق',
  'ring.presetFastDetail': 'يعيد الاتصال خلال نحو دقيقة من الإنهاء بالسحب · 1440 إيقاظًا يوميًا.',
  'ring.presetFastLabel': 'الأسرع — دقيقة واحدة',
  'ring.presetSaverDetail': 'يعيد الاتصال خلال نحو خمس عشرة دقيقة · 96 يوميًا.',
  'ring.presetSaverLabel': 'موفّر البطارية — 15 دقيقة',
  'ring.presetSuffix': '(إعداد {preset} المسبق)',
  'ring.reconnectBody': 'يُصلح منبّه المراقبة الرابط بعد أن يُنهي أندرويد أو HiOS التطبيق. ويستغرق الاسترداد بعد الإنهاء بالسحب ما يصل إلى المدة المختارة. وبينما يكون الرابط قائمًا لكنه غير محمي بعد — أي دون إبقاء صامت للاتصال، كما يحدث بعد إعادة التشغيل مباشرة — يقصّر التطبيق المنبّه من تلقاء نفسه إلى دقيقة واحدة، أيًّا كان المختار هنا.',
  'ring.reconnectTitle': 'سرعة إعادة الاتصال',
  'ring.statusChecking': 'جارٍ التحقق…',
  'ring.statusConnected': 'متصل — ترن المكالمات بينما يكون التطبيق في الخلفية.',
  'ring.statusOff': 'متوقف — لا ترن المكالمات إلا والتطبيق مفتوح.',
  'ring.statusStandby': 'في وضع الاستعداد — يحتفظ التطبيق بالاتصال بينما هو مفتوح.',
  'ring.statusUnsupported': 'هذا الإصدار لا يدعم رابط الخلفية.',
  'ring.statusWaiting': 'في انتظار أن يبدأه التطبيق.',
  'ring.stepAutoStart': 'إدارة التشغيل التلقائي',
  'ring.stepAutoStartDetail': 'Phone Master → صندوق الأدوات → إدارة التشغيل التلقائي → السماح لـ olmt-call بالعمل في الخلفية.',
  'ring.stepBatterySaver': 'موفّر البطارية وPower Boost، متوقفان',
  'ring.stepBatterySaverDetail': 'Phone Master → Power Marathon → Power Boost متوقف. لا تشغّل "التنظيف/التسريع" الخاص بـ Phone Master على هذا التطبيق.',
  'ring.stepLockApp': 'تثبيت التطبيق في التطبيقات الحديثة',
  'ring.stepLockAppDetail': 'افتح التطبيقات الحديثة، واضغط على 🔒 في بطاقة olmt-call حتى لا يتمكن المنظّف من إغلاقها.',
  'ring.stepPowerSaving': 'إدارة توفير الطاقة، متوقفة',
  'ring.stepPowerSavingDetail': 'الإعدادات → مختبر البطارية → إعدادات توفير البطارية → عطّل إدارة توفير الطاقة للتطبيقات.',
  'ring.stepPushBlock': 'حظر الإشعارات عند إطفاء الشاشة، متوقف',
  'ring.stepPushBlockDetail': 'الإعدادات المتقدمة → حظر الإشعارات عند إطفاء الشاشة، والسكون عند إطفاء الشاشة، والإشعارات المجدولة عند إطفاء الشاشة — كلها متوقفة.',
  'ring.tecnoBody': 'يجمّد HiOS خدمات الواجهة الأمامية والمقابس وفق جدوله الخاص، ولا توفّر Transsion أي واجهة برمجية لاكتشاف ذلك أو إصلاحه. هذه إعدادات وليست عمليات تثبيت — ولا يمكن للتطبيق تغييرها نيابة عنك.',
  'ring.tecnoTitle': 'إعدادات TECNO / HiOS',
  'ring.title': 'المكالمات في الخلفية',
  'ring.turnOff': 'إيقاف',
  'ring.turnOn': 'تشغيل',
  'search.clear': 'مسح البحث',
  'search.close': 'إغلاق البحث',
  'search.empty': 'لا توجد رسائل تطابق «{query}».',
  'search.failed': 'تعذّر البحث. حاول مرة أخرى.',
  'search.inThisChat': 'البحث في هذه المحادثة',
  'search.label': 'البحث في الرسائل',
  'search.loading': 'جارٍ البحث',
  'search.media': 'الوسائط',
  'search.messages': 'الرسائل',
  'search.more': 'المزيد',
  'search.olderThanLoaded': 'تلك الرسالة أقدم من الرسائل المحمّلة هنا.',
  'search.placeholder': 'البحث في الرسائل',
  'search.resultsOne': '{count} نتيجة لـ «{query}»',
  'search.resultsOther': '{count} نتائج لـ «{query}»',
  'search.resultsPartial': '{count} نتيجة أو أكثر لـ «{query}»',
  'spinner.loading': 'جارٍ التحميل',
  'time.today': 'اليوم',
  'time.yesterday': 'أمس',
  'voice.seek': 'موضع الرسالة الصوتية',
  'voice.speed': '{speed}',
  'voice.speedAction': 'سرعة التشغيل {speed} — اضغط للتغيير',
} satisfies Record<keyof typeof en, string>
